import { Modal } from "@/components/renderbus-modal";
import { RenderbusModalProps } from "@renderbus/ui/components/modal";

export default function UnbindModal({
  modalProps,
}: {
  modalProps: RenderbusModalProps;
}) {
  return <Modal {...modalProps}></Modal>;
}
